export default function VariantComboTableHeader({ selected, combos, setSelected }) {

  return (
    <div className="flex items-center gap-[1em] p-[0.5em] bg-[#f0f2ff]">
        <div className="flex items-center text-left">
            <input
                type="checkbox"
                className="h-4 w-4 accent-black"
                checked={selected.length === combos.length}
                ref={(el) => {
                    if (el) el.indeterminate = selected.length > 0 && selected.length < combos.length;
                }}
                onChange={() => {
                    const allSelected = selected.length === combos.length;
                    const allIds = combos.map((c) => c.variantUiId);
                    setSelected(allSelected ? [] : allIds);
                }}
            />
        </div>
        <div className="flex-1 max-w-[320px] text-left text-[15px] text-[#4b4b4b] font-semibold">Variant</div>
        <div className="flex-1 max-w-[11em] text-left text-[15px] text-[#4b4b4b] font-semibold">Price</div>
        <div className="flex-1 max-w-[7em] text-left text-[15px] text-[#4b4b4b] font-semibold">Inventory</div>
    </div>
  );
}
